import React from 'react';
import { mobileAppSection } from '../mockData';
import { Apple, Play } from 'lucide-react';
import { Button } from './ui/button';

const MobileAppSection = () => {
  return (
    <div className="mobile-app-section">
      <div className="container">
        <div className="mobile-app-grid">
          {/* Left Side - Phone Mockups */}
          <div className="mobile-mockups">
            <div className="phone phone-1">
              <img
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2JpbGUlMjBhcHB8ZW58MHx8fHwxNzYyNzA5NzYyfDA&ixlib=rb-4.1.0&q=85"
                alt="Mobile app screenshot"
              />
            </div>
            <div className="phone phone-2">
              <img
                src="https://images.pexels.com/photos/4050291/pexels-photo-4050291.jpeg"
                alt="Mobile app screenshot"
              />
            </div>
            <div className="phone phone-3">
              <img
                src="https://images.unsplash.com/photo-1551650975-87deedd944c3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxtb2JpbGUlMjBhcHB8ZW58MHx8fHwxNzYyNzA5NzYyfDA&ixlib=rb-4.1.0&q=85"
                alt="Mobile app screenshot"
              />
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="mobile-content">
            <div className="badge">{mobileAppSection.badge}</div>
            <h2 className="mobile-heading">{mobileAppSection.heading}</h2>
            <p className="mobile-description">{mobileAppSection.description}</p>
            <p className="mobile-subtext">{mobileAppSection.subtext}</p>
            
            <div className="download-buttons  h-10">
              <Button className="download-btn ios-btn">
                <Apple size={24} />
                <div className="btn-text  py-5 px-2">
                  <span className="btn-label">Download on</span>
                  <span className="btn-store">App Store</span>
                </div>
              </Button>
              <Button className="download-btn android-btn">
                <Play size={24} />
                <div className="btn-text">
                  <span className="btn-label">Get it on</span>
                  <span className="btn-store">Google Play</span>
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileAppSection;
